import { getAuthenticatedRequest } from "@/services/requestBuilder.js";
import { API_REQUESTS } from "@/constant/apiRequests.js";

export function createGetCustomerReviewsRequest() {
  return getAuthenticatedRequest(API_REQUESTS.PRIVATE.GET_CUSTOMER_REVIEWS);
}

export function createAddCustomerReviewRequest(customerReview) {
  return getAuthenticatedRequest(API_REQUESTS.PRIVATE.ADD_CUSTOMER_REVIEW, {
    customerReview,
  });
}

export function createUpdateCustomerReviewRequest(customerReview) {
  return getAuthenticatedRequest(API_REQUESTS.PRIVATE.UPDATE_CUSTOMER_REVIEW, {
    customerReview,
  });
}

export function createDeleteCustomerReviewRequest(id) {
  return getAuthenticatedRequest(API_REQUESTS.PRIVATE.DELETE_CUSTOMER_REVIEW, {
    customerReview: { sessionID: id },
  });
}
